import ListDevicesPage from './ListDevicesPage';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import { useGetMerchantByIdQuery } from '../../merchants/merchant.api-slice';
import { useParams } from 'react-router-dom';

const ListDevicesForMerchantPage: React.FC = () => {
  const { id } = useParams();
  const { data } = useGetMerchantByIdQuery(id ?? skipToken);

  return <ListDevicesPage merchant={data} scope={'merchant'} />;
};

export default ListDevicesForMerchantPage;
